import React, { Dispatch, SetStateAction } from "react";
import { IDocumentsInput } from "../../exports/interfaces";
import { Upload } from "lucide-react";
import {
  renderExistingFilePreview,
  renderFilePreview,
} from "../../exports/functions";

const Documents = ({
  documents,
  setDocuments,
}: {
  documents: IDocumentsInput;
  setDocuments: Dispatch<SetStateAction<IDocumentsInput>>;
}) => {
  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    inputFile: string,
  ) => {
    const file = e.target.files?.[0];
    if (file) {
      if (inputFile === "regCertificate") {
        setDocuments((prev) => ({
          ...prev,
          regCertificateFileName: file.name,
          regCertificateFile: file,
          regCertificateDocumentUrl: "",
        }));
      } else if (inputFile === "lawDocument") {
        setDocuments((prev) => ({
          ...prev,
          lawDocumentFileName: file.name,
          lawDocumentFile: file,
          lawDocumentDocumentUrl: "",
        }));
      } else if (inputFile === "foundingDocument") {
        setDocuments((prev) => ({
          ...prev,
          foundingDocumentFileName: file.name,
          foundingDocumentFile: file,
          foundingDocumentDocumentUrl: "",
        }));
      } else if (inputFile === "panDocumentFile") {
        setDocuments((prev) => ({
          ...prev,
          panDocumentFileName: file.name,
          panDocumentFile: file,
          panDocumentDocumentUrl: "",
        }));
      } else if (inputFile === "businessRegistrationFile") {
        setDocuments((prev) => ({
          ...prev,
          businessRegistrationFileName: file.name,
          businessRegistrationFile: file,
          businessRegistrationDocumentUrl: "",
        }));
      } else if (inputFile === "taxClearanceFile") {
        setDocuments((prev) => ({
          ...prev,
          taxClearanceFileName: file.name,
          taxClearanceFile: file,
          taxClearanceDocumentUrl: "",
        }));
      } else if (inputFile === "meetingDocument") {
        setDocuments((prev) => ({
          ...prev,
          meetingDocumentFileName: file.name,
          meetingDocumentFile: file,
          meetingDocumentDocumentUrl: "",
        }));
      } else if (inputFile === "agmDocumentFile") {
        setDocuments((prev) => ({
          ...prev,
          agmDocumentFileName: file.name,
          agmDocumentFile: file,
          agmDocumentDocumentUrl: "",
        }));
        // } else if (inputFile === "auditDocumentFile") {
        //   setDocuments((prev) => ({
        //     ...prev,
        //     auditDocumentFileName: file.name,
        //     auditDocumentFile: file,
        //   }));
      } else {
        setDocuments((prev) => ({
          ...prev,
          otherDocumentFileName: file.name,
          otherDocumentFile: file,
        }));
      }
    }
  };
  return (
    <>
      <div className={`dashboard-card mt-2`}>
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <div>
            <h6>Registration Documents</h6>
            <small>
              Registration certificate, bylaws, and founding documents
            </small>
          </div>
        </div>
        <div className="row g-2">
          <div className="col-12">
            <label className="form-label">
              Upload Registration Certificate (PDF, JPEG, PNG)
            </label>
            <div
              className={`upload-box p-4 ${!documents.regCertificateFile && !documents.regCertificateDocumentUrl && "text-center"}`}
            >
              {documents.regCertificateFile ? (
                renderFilePreview(
                  documents.regCertificateFile,
                  documents.regCertificateFileName,
                  (e: any) => handleFileChange(e, "regCertificate"),
                )
              ) : documents.regCertificateDocumentUrl ? (
                renderExistingFilePreview(
                  documents.regCertificateDocumentUrl,
                  (e: any) => handleFileChange(e, "regCertificate"),
                )
              ) : (
                <>
                  <Upload />

                  <p className="mb-1">
                    Choose a file or drag and drop it here.
                  </p>

                  <small className="d-block mb-3">
                    (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                  </small>

                  <label className="btn btn-badge text-main-color">
                    Browse file
                    <input
                      hidden
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e, "regCertificate");
                      }}
                    />
                  </label>
                </>
              )}
            </div>
          </div>
          <div className="col-12">
            <label className="form-label">
              Upload by law Document (PDF, JPEG, PNG)
            </label>

            <div
              className={`upload-box p-4 ${!documents.lawDocumentFile && !documents.lawDocumentDocumentUrl && "text-center"}`}
            >
              {documents.lawDocumentFile ? (
                renderFilePreview(
                  documents.lawDocumentFile,
                  documents.lawDocumentFileName,
                  (e: any) => handleFileChange(e, "lawDocument"),
                )
              ) : documents.lawDocumentDocumentUrl ? (
                renderExistingFilePreview(
                  documents.lawDocumentDocumentUrl,
                  (e: any) => handleFileChange(e, "lawDocument"),
                )
              ) : (
                <>
                  <Upload />

                  <p className="mb-1">
                    Choose a file or drag and drop it here.
                  </p>

                  <small className="d-block mb-3">
                    (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                  </small>

                  <label className="btn btn-badge text-main-color">
                    Browse file
                    <input
                      hidden
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e, "lawDocument");
                      }}
                    />
                  </label>
                </>
              )}
            </div>
          </div>
          <div className="col-12">
            <label className="form-label">
              Upload Founding Document (PDF, JPEG, PNG)
            </label>

            <div
              className={`upload-box p-4 ${!documents.foundingDocumentFile && !documents.foundingDocumentDocumentUrl && "text-center"}`}
            >
              {documents.foundingDocumentFile ? (
                renderFilePreview(
                  documents.foundingDocumentFile,
                  documents.foundingDocumentFileName,
                  (e: any) => handleFileChange(e, "foundingDocument"),
                )
              ) : documents.foundingDocumentDocumentUrl ? (
                renderExistingFilePreview(
                  documents.foundingDocumentDocumentUrl,
                  (e: any) => handleFileChange(e, "foundingDocument"),
                )
              ) : (
                <>
                  <Upload />

                  <p className="mb-1">
                    Choose a file or drag and drop it here.
                  </p>

                  <small className="d-block mb-3">
                    (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                  </small>

                  <label className="btn btn-badge text-main-color">
                    Browse file
                    <input
                      hidden
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e, "foundingDocument");
                      }}
                    />
                  </label>
                </>
              )}
            </div>
          </div>
          <div className="col-12">
            <label className="form-label">
              Upload PAN Registration Document (PDF, JPEG, PNG)
            </label>

            <div
              className={`upload-box p-4 ${!documents.panDocumentFile && !documents.panDocumentDocumentUrl && "text-center"}`}
            >
              {documents.panDocumentFile ? (
                renderFilePreview(
                  documents.panDocumentFile,
                  documents.panDocumentFileName,
                  (e: any) => handleFileChange(e, "panDocumentFile"),
                )
              ) : documents.panDocumentDocumentUrl ? (
                renderExistingFilePreview(
                  documents.panDocumentDocumentUrl,
                  (e: any) => handleFileChange(e, "panDocumentFile"),
                )
              ) : (
                <>
                  <Upload />

                  <p className="mb-1">
                    Choose a file or drag and drop it here.
                  </p>

                  <small className="d-block mb-3">
                    (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                  </small>

                  <label className="btn btn-badge text-main-color">
                    Browse file
                    <input
                      hidden
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e, "panDocumentFile");
                      }}
                    />
                  </label>
                </>
              )}
            </div>
          </div>
          <div className="col-12">
            <label className="form-label">
              Upload Business Registration Document (PDF, JPEG, PNG)
            </label>

            <div
              className={`upload-box p-4 ${!documents.businessRegistrationFile && !documents.businessRegistrationDocumentUrl && "text-center"}`}
            >
              {documents.businessRegistrationFile ? (
                renderFilePreview(
                  documents.businessRegistrationFile,
                  documents.businessRegistrationFileName,
                  (e: any) => handleFileChange(e, "businessRegistrationFile"),
                )
              ) : documents.businessRegistrationDocumentUrl ? (
                renderExistingFilePreview(
                  documents.businessRegistrationDocumentUrl,
                  (e: any) => handleFileChange(e, "businessRegistrationFile"),
                )
              ) : (
                <>
                  <Upload />

                  <p className="mb-1">
                    Choose a file or drag and drop it here.
                  </p>

                  <small className="d-block mb-3">
                    (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                  </small>

                  <label className="btn btn-badge text-main-color">
                    Browse file
                    <input
                      hidden
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e, "businessRegistrationFile");
                      }}
                    />
                  </label>
                </>
              )}
            </div>
          </div>
          <div className="col-12">
            <label className="form-label">
              Upload Tax Clearance Document (PDF, JPEG, PNG)
            </label>

            <div
              className={`upload-box p-4 ${!documents.taxClearanceFile && !documents.taxClearanceDocumentUrl && "text-center"}`}
            >
              {documents.taxClearanceFile ? (
                renderFilePreview(
                  documents.taxClearanceFile,
                  documents.taxClearanceFileName,
                  (e: any) => handleFileChange(e, "taxClearanceFile"),
                )
              ) : documents.taxClearanceDocumentUrl ? (
                renderExistingFilePreview(
                  documents.taxClearanceDocumentUrl,
                  (e: any) => handleFileChange(e, "taxClearanceFile"),
                )
              ) : (
                <>
                  <Upload />

                  <p className="mb-1">
                    Choose a file or drag and drop it here.
                  </p>

                  <small className="d-block mb-3">
                    (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                  </small>

                  <label className="btn btn-badge text-main-color">
                    Browse file
                    <input
                      hidden
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e, "taxClearanceFile");
                      }}
                    />
                  </label>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={`dashboard-card mt-2`}>
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <div>
            <h6>Meeting Documents</h6>
            <small>Board meeting minutes, resolutions</small>
          </div>
        </div>
        <div className="row g-2">
          <div className="col-12">
            <label className="form-label">
              Upload Board Meeting Minutes (PDF, JPEG, PNG)
            </label>

            <div
              className={`upload-box p-4 ${!documents.meetingDocumentFile && !documents.meetingDocumentDocumentUrl && "text-center"}`}
            >
              {documents.meetingDocumentFile ? (
                renderFilePreview(
                  documents.meetingDocumentFile,
                  documents.meetingDocumentFileName,
                  (e: any) => handleFileChange(e, "meetingDocument"),
                )
              ) : documents.meetingDocumentDocumentUrl ? (
                renderExistingFilePreview(
                  documents.meetingDocumentDocumentUrl,
                  (e: any) => handleFileChange(e, "meetingDocument"),
                )
              ) : (
                <>
                  <Upload />

                  <p className="mb-1">
                    Choose a file or drag and drop it here.
                  </p>

                  <small className="d-block mb-3">
                    (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                  </small>

                  <label className="btn btn-badge text-main-color">
                    Browse file
                    <input
                      hidden
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e, "meetingDocument");
                      }}
                    />
                  </label>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={`dashboard-card mt-2`}>
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <div>
            <h6>Minutes of the General Meeting</h6>
            <small>Annual General Meeting minutes and reports</small>
          </div>
        </div>
        <div className="row g-2">
          <div className="col-12">
            <label className="form-label">
              Upload Board Meeting Minutes (PDF, JPEG, PNG)
            </label>

            <div
              className={`upload-box p-4 ${!documents.agmDocumentFile && !documents.agmDocumentDocumentUrl && "text-center"}`}
            >
              {documents.agmDocumentFile ? (
                renderFilePreview(
                  documents.agmDocumentFile,
                  documents.agmDocumentFileName,
                  (e: any) => handleFileChange(e, "agmDocumentFile"),
                )
              ) : documents.agmDocumentDocumentUrl ? (
                renderExistingFilePreview(
                  documents.agmDocumentDocumentUrl,
                  (e: any) => handleFileChange(e, "agmDocumentFile"),
                )
              ) : (
                <>
                  <Upload />

                  <p className="mb-1">
                    Choose a file or drag and drop it here.
                  </p>

                  <small className="d-block mb-3">
                    (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                  </small>

                  <label className="btn btn-badge text-main-color">
                    Browse file
                    <input
                      hidden
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e, "agmDocumentFile");
                      }}
                    />
                  </label>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <div className={`dashboard-card mt-2`}>
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <div>
            <h6>Audit Documents</h6>
            <small>Audit reports and financial statements</small>
          </div>
        </div>
        <div className="row g-2">
          <div className="col-12">
            <label className="form-label">
              Upload Documents (PDF, JPEG, PNG)
            </label>

            <div className="upload-box text-center p-4">
              <div className="mb-2">
                <i><Upload/></i>
              </div>

              <p className="mb-1">Choose a file or drag and drop it here.</p>

              <small className="d-block mb-3">
                (txt, docx, xlsx, pdf, jpeg, png- Up to 100 mb)
              </small>

              {documents.auditDocumentFileName && <small className="d-block mb-3">{documents.auditDocumentFileName}</small>}

              <label className="btn btn-badge text-main-color px-4 mb-0">
                {documents.auditDocumentFileName ? "Change file" : "Browse file"}
                <input
                  type="file"
                  hidden
                  onChange={(e) => {
                    handleFileChange(e, "auditDocumentFile");
                  }}
                />
              </label>
            </div>
          </div>
        </div>
      </div> */}
      <div className={`dashboard-card mt-2`}>
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <div>
            <h6>Other Supporting Documents</h6>
            <small>Any additional supporting documents</small>
          </div>
        </div>
        <div className="row g-2">
          <div className="col-12">
            <label className="form-label">
              Upload Documents (PDF, JPEG, PNG)
            </label>

            <div
              className={`upload-box p-4 ${!documents.otherDocumentFile && !documents.otherDocumentDocumentUrl && "text-center"}`}
            >
              {documents.otherDocumentFile ? (
                renderFilePreview(
                  documents.otherDocumentFile,
                  documents.otherDocumentFileName,
                  (e: any) => handleFileChange(e, "otherDocumentFile"),
                )
              ) : documents.otherDocumentDocumentUrl ? (
                renderExistingFilePreview(
                  documents.otherDocumentDocumentUrl,
                  (e: any) => handleFileChange(e, "otherDocumentFile"),
                )
              ) : (
                <>
                  <Upload />

                  <p className="mb-1">
                    Choose a file or drag and drop it here.
                  </p>

                  <small className="d-block mb-3">
                    (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                  </small>

                  <label className="btn btn-badge text-main-color">
                    Browse file
                    <input
                      hidden
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e, "otherDocumentFile");
                      }}
                    />
                  </label>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Documents;
